import React, { useEffect, useState } from "react";
import axios from "axios";
import { Authorization } from "../../../Context/Authorization";
import { toast } from "react-toastify";
import Preloader from "../../../shared/PreLoaders";
import { Modal, Button, Form } from "react-bootstrap";

const inputStyle = {
  width: "100%",
  padding: "9px 12px",
  border: "1.5px solid #E2E8F0",
  borderRadius: 8,
  fontSize: 13,
  color: "#1A202C",
  background: "#fff",
  outline: "none",
};

const ManageETVisitorFee = () => {
  const Api = process.env.REACT_APP_API;

  const [ecoTourisms, setEcoTourisms] = useState([]);
  const [selectedEcoTourism, setSelectedEcoTourism] = useState("");
  const [fees, setFees] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editingFee, setEditingFee] = useState(null);
  const [editForm, setEditForm] = useState({
    feeType: "",
    amount: "",
  });

  useEffect(() => {
    fetchEcoTourisms();
  }, []);

  useEffect(() => {
    if (selectedEcoTourism) {
      fetchFees(selectedEcoTourism);
    } else {
      setFees([]);
    }
  }, [selectedEcoTourism]);

  const fetchEcoTourisms = async () => {
    try {
      setLoading(true);
      const config = Authorization();

      const res = await axios.get(`${Api}/api/eco-tourism`, config);
      setEcoTourisms(res.data.data || []);
    } catch {
      toast.error("Failed to load Eco Tourism list");
    } finally {
      setLoading(false);
    }
  };

  const fetchFees = async (ecoTourismId) => {
    try {
      setLoading(true);
      const config = Authorization();

      const res = await axios.get(
        `${Api}/api/eco-tourism-fees/${ecoTourismId}`,
        config
      );

      setFees(res.data.fees || []);
    } catch {
      toast.error("Failed to load fees");
    } finally {
      setLoading(false);
    }
  };

  const openEditModal = (fee) => {
    setEditingFee(fee);
    setEditForm({
      feeType: fee.feeType,
      amount: fee.amount,
    });
    setShowEditModal(true);
  };

  const handleUpdateFee = async () => {
    if (!editForm.feeType.trim()) {
      toast.error("Fee type is required");
      return;
    }

    if (!editForm.amount || Number(editForm.amount) < 0) {
      toast.error("Enter valid amount");
      return;
    }

    try {
      setLoading(true);
      const config = Authorization();

      await axios.put(
        `${Api}/api/eco-tourism-fees/${editingFee._id}`,
        {
          feeType: editForm.feeType,
          amount: Number(editForm.amount),
        },
        config
      );

      toast.success("Fee updated successfully");
      setShowEditModal(false);
      fetchFees(selectedEcoTourism);
    } catch {
      toast.error("Failed to update fee");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (feeId) => {
    if (!window.confirm("Delete this fee?")) return;

    try {
      setLoading(true);
      const config = Authorization();

      await axios.delete(
        `${Api}/api/eco-tourism-fees/${feeId}`,
        config
      );

      toast.success("Fee deleted successfully");
      fetchFees(selectedEcoTourism);
    } catch {
      toast.error("Failed to delete fee");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Preloader loading={loading} />

      <div style={{ marginBottom: 20 }}>
        <h4
          style={{
            margin: 0,
            fontWeight: 700,
            color: "#1A202C",
            fontSize: 18,
          }}
        >
          Manage ET Visitor Fees
        </h4>
      </div>

      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          border: "1px solid #E2E8F0",
          boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            padding: "20px",
            borderBottom: "1px solid #E2E8F0",
          }}
        >
          <label
            style={{
              fontSize: 13,
              fontWeight: 600,
              marginBottom: 8,
              display: "block",
            }}
          >
            Select Eco Tourism
          </label>

          <select
            value={selectedEcoTourism}
            onChange={(e) => setSelectedEcoTourism(e.target.value)}
            style={inputStyle}
          >
            <option value="">Select Eco Tourism</option>
            {ecoTourisms.map((eco) => (
              <option key={eco._id} value={eco._id}>
                {eco.ecoTourismName} - {eco.ecoTourismLocation}
              </option>
            ))}
          </select>
        </div>

        <div style={{ padding: 20 }}>
          {!selectedEcoTourism ? (
            <div style={emptyStyle}>
              Select an Eco Tourism location to view fees
            </div>
          ) : fees.length === 0 ? (
            <div style={emptyStyle}>No fees found</div>
          ) : (
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr style={{ background: "#F7FAFC" }}>
                  <th style={thStyle}>Fee Type</th>
                  <th style={thStyle}>Amount</th>
                  <th style={thStyle}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {fees.map((fee) => (
                  <tr key={fee._id}>
                    <td style={tdStyle}>{fee.feeType}</td>
                    <td style={tdStyle}>₹ {fee.amount}</td>
                    <td style={tdStyle}>
                      <div style={{ display: "flex", gap: 8, alignItems: "center", paddingTop: 4 }}>

                        <i className="mdi mdi-pencil" title="Edit"
                          style={{ fontSize: "1.2rem", cursor: "pointer", color: "#1565C0" }}
                          onClick={() => openEditModal(fee)} />

                        <i className="mdi mdi-delete" title="Delete"
                          style={{ fontSize: "1.2rem", cursor: "pointer", color: "#C62828" }}
                          onClick={() => handleDelete(fee._id)} />

                      </div>
                     
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Fee</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Fee Type</Form.Label>
            <Form.Control
              type="text"
              value={editForm.feeType}
              onChange={(e) =>
                setEditForm({
                  ...editForm,
                  feeType: e.target.value,
                })
              }
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Amount</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={editForm.amount}
              onChange={(e) =>
                setEditForm({
                  ...editForm,
                  amount: e.target.value,
                })
              }
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowEditModal(false)}
          >
            Cancel
          </Button>

          <Button
            variant="success"
            onClick={handleUpdateFee}
          >
            Update Fee
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const thStyle = {
  padding: "12px",
  textAlign: "left",
  borderBottom: "1px solid #E2E8F0",
  fontSize: 13,
};

const tdStyle = {
  padding: "12px",
  borderBottom: "1px solid #EDF2F7",
  fontSize: 13,
};

const emptyStyle = {
  textAlign: "center",
  color: "#718096",
  padding: 40,
};

export default ManageETVisitorFee;